import React, { useCallback } from "react";
import UploadButton from "../buttons/uploadButton";
import { FILTERS_SECTION } from "../../constants/translates";
import { ImportDeclarant } from "./Interfaces";
import Authorize from "../Authorize";
import { UPLOAD_XML } from "../../constants/authorize";

interface Props {
  store: ImportDeclarant;
}

const ImportDeclarants: React.FC<Props> = ({ store }) => {
  const onFileReadyToUpload = useCallback(
    (fileList: FileList) => {
      store.importDeclarant(fileList);
    },
    [store]
  );

  return (
    <Authorize permission={UPLOAD_XML}>
      <UploadButton
        onFileReady={onFileReadyToUpload}
        id="upload-declarant"
        multiple
      >
        {FILTERS_SECTION.upload}
      </UploadButton>
    </Authorize>
  );
};

export default ImportDeclarants;
